import { CoreSignupInfoService } from "../core/signup-info-service";

export class DevSignupInfoService extends CoreSignupInfoService
{
    
}